import { Routes, RouterModule } from '@angular/router';

import { LabelingComponent } from './labeling/labeling.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './auth-guard.service';

const appRoutes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login-page', component: LoginComponent },
  { path: 'labeling-page', component: LabelingComponent, canActivate: [AuthGuardService] },
  // otherwise redirect to home
  { path: '**', redirectTo: 'login-page' },
];

export const routing = RouterModule.forRoot(appRoutes);
